import type { RouteLocationNormalized, RouteLocationRaw } from 'vue-router';
import { useRemoteConfigStore } from '@/shared/firebase';
import { useComexPendingOperationsStore } from '@/shared/comex/stores/comexPendingOperations.store';

/**
 * Redirige a movimientos cuando la empresa no tiene COMEX disponible, cerrando el acceso por URL.
 * Espera a Remote Config antes de leer el gate: en carga fría los guards corren antes de que
 * `App.vue` lo inicialice y `feature_comex` leería su default `false`.
 *
 * @param to - ruta destino; solo actúa sobre el subárbol `/comex`, sin distinguir mayúsculas
 * @returns `true` para continuar, o `{ name: 'movements' }` si COMEX no está disponible
 */
export async function validateComexAvailability(
  to: RouteLocationNormalized
): Promise<boolean | RouteLocationRaw> {
  if (!to.path.toLowerCase().startsWith('/comex')) {
    return true;
  }

  const remoteConfigStore = useRemoteConfigStore();
  await remoteConfigStore.initialize();

  const comexPendingOperationsStore = useComexPendingOperationsStore();

  if (!comexPendingOperationsStore.isComexAvailable) {
    return { name: 'movements' };
  }

  return true;
}
